import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import {styles} from "../styles/consultCompleteStyles"

type Props = {
  title?: string;
  message?: string;
  showDebugPath?: boolean;
};

export default function PageNotFound({
  title = "Page not found",
  message = "This link is invalid or has expired.",

}: Props) {
    const navigate = useNavigate()
   
    useEffect(() => {
        // Add a guard history entry so "Back" triggers popstate we can intercept.
        window.history.pushState({ guard: true }, "", window.location.href);

        const onPopState = () => {
            // Attempt close (only works if tab was opened by script)
            window.close();
            // Fallback: send user to landing
            navigate("/", { replace: true });
        };

        window.addEventListener("popstate", onPopState);
        return () => window.removeEventListener("popstate", onPopState);
    }, [navigate]);
 

  return (
    <div style={styles.wrap}>
      {/* Soft animated blobs */}
      <div style={styles.blobA} />
      <div style={styles.blobB} />

      <div style={styles.center}>
        <div style={styles.card}>
          <div style={styles.badge}>404</div>

          <h1 style={styles.h1}>{title}</h1>
          <p style={styles.p}>{message}</p>

          <div style={styles.footer}>
            If you believe this is an error, ask your provider for a new consult link.
          </div>
        </div>
      </div>
    </div>
  );
}

